export default "__VITE_ASSET___Gy4fH1J__"